import { styled } from "@mui/material/styles";

const sizesFactory = {
  extraSmall: "5px",
  small: "5px",
  medium: "8px",
  large: "10px",
};
interface DotContainerProps {
  size: "small" | "medium" | "large" | "extraSmall";
  color: "primary" | "secondary";
}

export const DotContainer = styled("span")<DotContainerProps>(({ theme, size, color }) => ({
  lineHeight: 0,
  "& span": {
    height: sizesFactory[size],
    width: sizesFactory[size],
    margin: "2px",
    backgroundColor: color === "primary" ? theme.palette.primary.main : theme.palette.common.white,
  },
}));

export const Dot = styled("span")(() => ({
  animation: "dot 1.2s infinite ease-out both",
  display: "inline-flex",
  borderRadius: "50%",

  "&:nth-of-type(2)": { animationDelay: "200ms" },
  "&:nth-of-type(3)": { animationDelay: "400ms" },

  "@keyframes dot": {
    "0%": { transform: "scale(0.25)" },
    "40%": { transform: "scale(1.25)" },
    "80%, 100%": { transform: "scale(0)" },
  },
}));
